import axios from 'axios'

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getPropertyDetail = (slug) => {
  return axios.get(`${process.env.API_URL}/properties/?filters[slug][$eq]=${slug}&populate=*`)
}


/**
* Function to get token
* @param {Object} payload
* @return AxiosPromise
*/
export const getPropertyMarket = (id) => {
 return axios.get(`${process.env.API_URL}/market-properties/?filters[id][$eq]=${id}&populate[Image]=*`)
}

/**
* Function to get token
* @param {Object} payload
* @return AxiosPromise
*/
export const getPropertyDocuments = (id) => {
  return axios.get(`${process.env.API_URL}/property-documents/?filters[id][$eq]=${id}&populate[Document]=*`)
 }

 /**
* Function to get token
* @param {Object} payload
* @return AxiosPromise
*/
export const getPropertyTooltips = () => {
  return axios.get(`${process.env.API_URL}/property-config-tooltip`)
 }